// Zombie-themed suit mapping for Solitaire.
// Hearts → Brains (green pink), Diamonds → Blood drops (red),
// Spades → Tombstones (dark), Clubs → Bones (white). Rank labels are
// standard A/2..10/J/Q/K so the game stays readable.
//
// NOTE: `color` is the CSS color used for the small RANK + suit-letter text
// on the card face (cream/off-white background). The big center symbol is an
// emoji so it renders in its native colors regardless. That means we can
// give Bones a dark text color for legibility while the 🦴 emoji stays
// naturally bone-colored. Same trick for Brains/Blood (red text + emoji).
export const SUIT_META = {
  H: { name: "Brains",     symbol: "🧠", color: "#c81d3a", colorDark: "#7a0f23" },
  D: { name: "Blood",      symbol: "🩸", color: "#c81d3a", colorDark: "#7a0f23" },
  S: { name: "Tombstones", symbol: "🪦", color: "#1a1a1f", colorDark: "#0a0a0f" },
  C: { name: "Bones",      symbol: "🦴", color: "#3a2820", colorDark: "#1f140e" },
};

export const RANK_LABEL = {
  1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7",
  8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K",
};
